import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type { FC } from "react";
import { type Recommendation, Severity } from "../../../utils/models";
import SystemButton from "../../UIToolkit/SystemButton/SystemButton";
import { RecommendationsColor } from "../RecommendationColor";

type RecommendationsHeaderProps = {
	count: number;
	selectedSeverities: ReadonlySet<Severity>;
	recommendationsBySeverity: ReadonlyMap<Severity, Recommendation[]>;
	onSelect: (severity: Severity) => void;
	onSelectAll: () => void;
};

export const RecommendationsHeader: FC<RecommendationsHeaderProps> = ({ count, selectedSeverities, recommendationsBySeverity, onSelect, onSelectAll }) => {
	const isAllSelected = selectedSeverities.size === Object.keys(Severity).length;
	return (
		<Box>
			<Box sx={{ display: "flex", gap: 0.5, mb: 3, flexWrap: "wrap" }}>
				<SystemButton
					onClick={onSelectAll}
					sx={{
						minWidth: "auto",
						px: 1.5,
						py: 0.5,
						fontSize: "12px",
						color: "primary.dark",
						bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
						opacity: isAllSelected ? 1 : 0.4,
						"&:hover": { bgcolor: "#E3E4F0", opacity: 1 },
					}}
				>
					All
				</SystemButton>
				{Object.entries(Severity).map(([key, severity]) => (
					<SystemButton
						key={key}
						onClick={() => onSelect(severity)}
						sx={{
							minWidth: "auto",
							px: 1.5,
							py: 0.5,
							gap: 0.5,
							color: "primary.dark",
							fontSize: "12px",
							bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
							opacity: selectedSeverities.has(severity) ? 1 : 0.4,
							whiteSpace: "nowrap",
							"&:hover": { bgcolor: "#E3E4F0", opacity: 1 },
						}}
					>
						<RecommendationsColor severity={severity} />
						{key} ({recommendationsBySeverity.get(severity)?.length ?? 0})
					</SystemButton>
				))}
			</Box>
			Suggestions ({count})
		</Box>
	);
};
